import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import type { IntlShape } from 'react-intl'
import { useIntl } from 'react-intl'
import cn from 'classnames'

import { useSystem } from 'src/hooks/useSystem'
import { usePage } from 'src/hooks/usePage'
import { loginRequestAction } from 'client/contexts/Login/actions'
import { MIN_LENGTH } from 'client/helpers/Form/constants'
import { validateEmail, validatePassword } from 'client/helpers/Form'

import styles from './styles.module.css'
import { LoginAndSignUpForm } from 'src/comps/LoginAndSignUpForm'
import { getStatus } from 'client/contexts/Login/selectors'

interface ILoginForm {
  title?: boolean
  border?: boolean
  from?: string
}

type fieldError = { id: string }[] | null

export function getLoginText(from: string, intl: IntlShape) {
  if (from === 'price-watch') {
    return intl.formatMessage(
      { id: 'pw.login-body' },
      { pwLoginBodyBold: <strong>{intl.formatMessage({ id: 'pw.login-body-bold' })}</strong> }
    )
  }

  if (from === 'liked-property') {
    return intl.formatMessage({ id: 'property-like.login-body' })
  }

  return `${intl.formatMessage({ id: 'global.login-body2' })} ${intl.formatMessage({
    id: 'global.login-body',
  })}`
}

const LoginForm = ({ title: showTitle = false, border = false, from = '' }: ILoginForm) => {
  const intl = useIntl()
  const dispatch = useDispatch()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errors, setErrors] = useState<{ email: fieldError; password: fieldError }>({
    email: null,
    password: null,
  })

  const { apiHostName } = useSystem()
  const { pageId } = usePage()

  const status = useSelector(getStatus)

  useEffect(() => {
    if (status === 'rejected') {
      setErrors({
        email: [{ id: 'errorEmail' }],
        password: [{ id: 'incorrectPassword' }],
      })
    }
  }, [status])

  function validForm() {
    const error = {
      email: validateEmail(email, { required: true }),
      password: validatePassword(password, { required: true, min: MIN_LENGTH }),
    }

    setErrors(error)
    return !error.email && !error.password
  }

  function handleSubmitForm(event: React.FormEvent) {
    event.preventDefault()
    event.stopPropagation()

    if (!validForm()) {
      return
    }

    dispatch(
      loginRequestAction({
        hostname: apiHostName,
        data: { email, password, pageId, from },
      })
    )
  }

  const formTitle = showTitle ? intl.formatMessage({ id: 'global.login' }) : null
  const text = getLoginText(from, intl)

  return (
    <div className={cn(styles.loginForm, { [styles.border]: border })}>
      <LoginAndSignUpForm
        title={formTitle}
        text={text}
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        handleSubmitForm={handleSubmitForm}
        errors={errors}
        isSignUp={false}
        showTerms
        from={from}
      />
    </div>
  )
}

export default LoginForm
